<template>
<div class="searchResulte">
  <div class="searchResulte_nav_placeholder">
    <div class="searchResulte_nav">
      <span class="searchResulte_nav_all icon-classify" @click="navShow"></span>
      <span class="searchResulte_nav_text" :class="tabIndex==1?'blackColor':''" @click="muneClick(1)">综合</span><i class="icon-line searchResulte_nav_icon_line "></i>
      <span class="searchResulte_nav_text" :class="tabIndex==2?'blackColor':''" @click="muneClick(2)">最新</span><i class="icon-line searchResulte_nav_icon_line"></i>
      <span class="searchResulte_nav_text" :class="tabIndex==3?'blackColor':''" @click="muneClick(3)">销量</span><i class="icon-line searchResulte_nav_icon_line"></i>
      <span class="searchResulte_nav_text" :class="tabIndex==4?'blackColor':''" @click="muneClick(4)">价格</span>
    </div>
  </div>
  <div class="coupon_goods_list_wrapper">
    <div class="coupon_goods_list_ul">
      <!--list1本地搜索-->
      <router-link :to="{ name: 'item', params: { id: dataList.num_iid},query:{tkUrl:dataList.tkUrl,coupon:dataList.couponPrice}}" v-for="(dataList,index) in dataLists" :key="dataList.num_iid" class="coupon_goods_list_li">
        <div class="li_top">
          <img v-lazy="dataList.pict_url" class="goods_pic" />
          <p v-if="index==0" class="left_coupon">还剩{{dataList.coupon_remain_count}} 张券</p>
        </div>
        <div class="li_btm">
          <p class="goods_title">{{dataList.title.slice(0,36)}}</p>
          <p class="goods_shop">
            <img src="../../images/tmallSelected.png" v-if="dataList.user_type=='1'" class='n_goods_shop_img' />
            <img src="../../images/taobao.png" v-if="dataList.user_type=='0'" class='n_goods_shop_img' />
            <!--img src="../../images/haitao.png" v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
            <img src="../../images/juhuasuan.png" v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
            <img src="../../images/taoqianggou.png" v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
            <img src="../../images/video.png" v-if="dataList.isVideo==1" class='n_goods_shop_img' /-->{{dataList.shop_title}}</p>
          <div class="goods_coupon_h">
            <div class="goods_coupon" v-if="dataList.couponPrice!=0">
              <span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.couponPrice
  }}</span>
            </div>
          </div>
          <div class="goods_money">
            <span class="goods_money_l"><span class="s1">券后</span><span class="s2">{{dataList.finalPrice}}</span></span>
            <span class="goods_money_r">原价￥{{dataList.zk_final_price}}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
  <!--弹出分类-->
  <mt-popup v-model="navShowFlag" position="top" modal="true" closeOnClickModal="true" class="pop_nav_all">
    <div>
      <ul class="catalog_wrapper">
        <li v-for="(catalogList) in catalogList" class="catalog_cell" :key="catalogList.catalogList" @click="classifyGoods(catalogList.goodsCat)">
          {{catalogList.catalog}}
        </li>
      </ul>
    </div>

  </mt-popup>
</div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
import Vue from 'vue'
import {
  Popup
} from 'mint-ui'
Vue.component(Popup.name, Popup);
import catalogList from "../../configFile/catalog/catalog.json"
import {
  Indicator,
  Lazyload
} from 'mint-ui' //提示搜索优惠券
import {
  addScore
} from "../../common/js/common.js"
Vue.use(Lazyload);
export default {
  name: "searchResult",
  data() {
    return {
      page: 1, //本地券结果集页号
      pageSize: 10, //本地券每页记录数
      sort: '', //默认排序方式
      dataLists: [],
      catalogList: catalogList.catalogListArray,
      q: '',
      REQUIRE: false,
      tabIndex: 1,
      keyword: "",
      cat: "",
      navShowFlag: false,
      openID:''

    }

  },
  methods: {
    /*axios调用数据*/
    login() {
      this.url = "api/searchAPI.php?page_no=" + this.page + "&page_size=" + this.pageSize + "&q=" + this.keyword + "&has_coupon=false&adzone_id=106344537&is_overseas=false&is_tmall=false&sort=" + this.sort + "&cat=" + this.cat
      //console.log(this.url)
      this.$ajax.autoService
        .login(this.url)
        .then((res) => {
          //console.log(res)
          this.dataLists = this.dataLists.concat(res.data.result_list.map_data.map(function(item) {
            if (item.coupon_id) {
              item.tkUrl = item.coupon_share_url
              item.couponPrice = item.coupon_info.match(/[\d\.]+/g)[1]
            } else {
              item.tkUrl = item.url
              item.couponPrice = 0

            }

            item.finalPrice = (item.zk_final_price - item.couponPrice).toFixed(2)
            var temp = item.pict_url
            temp = temp.replace('https:', '')
            temp = temp.replace('http:', '')
            item.pict_url = "https:" + temp
            return item
          }))


          //this.loading = false
          this.$nextTick(() => {
            this.REQUIRE = true;
            this.loading = false;
            Indicator.close()
            if (res.data.result_list.map_data == 0) { //如果数据已无，则不滑动数据
              this.REQUIRE = false
            }
          });
          //console.log(this.dataLists)
        }, (res) => {
          console.log("error")
          this.REQUIRE = true;
        })
    },
    /*axios向下加载*/
    scrollBottom() {
      //console.log(this.page)
      // 滚动到页面底部时，请求前一天的文章内容
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (((window.screen.height + scrollTop) > (document.body.clientHeight) - 10) && this.REQUIRE) {
        // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
        Indicator.open('正在加载优惠券');
        this.REQUIRE = false;
        this.page += 1
        //console.log(this.page)
        this.login()

      }
    },
    /*tab选择搜索*/
    muneClick: function(type) {
      this.dataLists = []
      this.page = 1
      switch (type) {
        case 2:
          this.tabIndex = "2"
          this.sort = 'tk_rate_des'
          this.login()
          break;
        case 3:
          this.tabIndex = 3
          this.sort = 'total_sales_des'
          this.login()
          break;
        case 4:
          this.tabIndex = 4
          this.sort = 'price_asc'
          this.login()
          break;
        default:
          this.tabIndex = 1
          this.sort = ''
          this.login()
          break;

      }
    },
    navShow: function() { //展开全部分类
      this.navShowFlag = !this.navShowFlag

    },
    classifyGoods: function(cat) {
      this.navShowFlag = !this.navShowFlag
      this.cat = cat
      this.dataLists = []
      this.page = 1
      this.login()
    }

  },
  created() {
    this.keyword = this.$route.query.keyWord //获取关键词
    if(sessionStorage.userInfo){
      this.openID=JSON.parse(sessionStorage.userInfo).openId
    }
    if (this.openID) {
      var that = this;
      addScore('搜券', this.openID, function(score) {
        that.$store.dispatch('cancelScore', {
          total: that.$store.state.scoreUserInfo.totalScore * 1,
          userScore: -score * 1
        })
      })

    }
    if (this.$route.query.cat) {
      this.cat = this.$route.query.cat
    }
    //获取栏目
    //this.searchType = this.$route.params.searchType
    //console.log(typeof(this.page))
    this.login()
  },
  mounted() {
    window.onscroll = this.scrollBottom
  },
  beforeDestroy() {
    Indicator.close()
    window.onscroll = ""
  }
}
</script>

<style lang="stylus">
  .searchResulte_nav_placeholder
    width:100%
    height:80px
    .searchResulte_nav
      width:100%
      height:80px
      background:#fff
      display:flex
      .searchResulte_nav_all
        flex:0 0 150px
        text-align:center
        line-height:60px
        font-size:30px
        color:#666
        box-sizing:border-box
        border-right:1px solid #f2f2f2
        margin-top:10px
        height:60px
      .searchResulte_nav_text
        flex:1
        text-align:center
        font-size:26px
        color:#999
        line-height:80px
        &.blackColor
            color:#333
      .searchResulte_nav_icon_line
        flex:0 0 2px
        line-height:80px
  .coupon_goods_list_wrapper
    width:750px
    overflow:hidden
    .coupon_goods_list_ul
      width:760px
      .coupon_goods_list_li
        width:370px
        float:left;
        margin:10px 10px 0 0
        padding:0 0 20px 0
        background:#fff
        border:1px solid #e6e6e6
        box-sizing:border-box
        .li_top
          width:100%
          height:368px
          position:relative
          .goods_pic
            width:100%
            height:368px
          .left_coupon
            width:100%
            position:absolute
            left:0px
            bottom:0px
            height:40px
            background:rgba(255,101,0,0.6)
            color:#fff
            font-size:24px
            text-align:center
            line-height:40px
        .li_btm
          padding:10px 15px
          .goods_title
            font-size:28px
            color:#333
            line-height:32px
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            height:60px
          .goods_shop
            font-size:20px
            color:#999
            margin-top:10px
            overflow:hidden
            text-overflow:ellipsis
            white-space:nowrap
            .n_goods_shop_img
              width:20px
              height:20px
              display:inline-block
              vertical-align:middle
              margin-left:10px
          .goods_coupon_h
            width:100%
            height:36px
            margin-top:15px
            .goods_coupon
              height:36px
              color:#fff
              line-height:36px
              font-size:0px
              .goods_coupon_l
                padding:0 8px
                background:#ff6500
                display:inline-block
                vertical-align:top
                font-size:22px
                height:36px
              .goods_coupon_c
                width:13px
                height:36px
                vertical-align:top
              .goods_coupon_r
                background:#ff5400
                display:inline-block
                vertical-align:top
                padding:0 10px
                height:36px
                font-size:22px
          .goods_money
            display:flex
            margin-top:15px
            justify-content:space-between
            line-height:30px
            .goods_money_l
              color:#f40
              .s1
                font-size:22px
                margin-right:5px
              .s2
                font-size:30px
            .goods_money_r
              font-size:22px
              color:#999
              text-decoration: line-through
  .pop_nav_all
    width:100%
    top:80px
  .catalog_wrapper
    background:#fff
    padding:30px
    .catalog_cell
      background:#f2f2f2
      display:inline-block
      padding:20px 30px
      border-radius:10px
      font-size:28px
      margin:10px
</style>



// WEBPACK FOOTER //
// src/components/search/searchResulte.vue